import React from 'react'
import ErrorLayoutContainer from './ErrorLayoutContainer'

const ErrorLayout = (props) => <ErrorLayoutContainer {...props} />
export default ErrorLayout
